import React from 'react'

function Footer(): React.JSX.Element {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          &copy; {currentYear} McQueens Customer Portal. All rights
          reserved.
        </p>
        <nav className="footer-nav">
          <ul>
            <li>
              <a href="https://www.mcqueensdairies.co.uk/privacy-and-cookies-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
            </li>
            <li>
              <a href="https://www.mcqueensdairies.co.uk/terms-and-conditions/" target="_blank" rel="noreferrer">Terms and Conditions</a>
            </li>
            <li>
              <a href="https://www.mcqueensdairies.co.uk/help/" target="_blank" rel="noreferrer">Customer Services</a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  )
}

export default Footer
